<template>
  <div class="consultation-header">
    <v-layout justify-space-between wrap>
      <v-flex sm2>
        <v-text-field
          outlined
          hide-details
          label="N° Devis"
          v-model="project.quotation_number"
        ></v-text-field>
      </v-flex>
      <v-flex sm2>
        <v-text-field
          outlined
          hide-details
          label="N° Commande"
          v-model="project.order_number"
        ></v-text-field>
      </v-flex>
      <v-flex sm8>
        <v-layout justify-space-between wrap>
          <v-flex sm3>
            <v-text-field
              outlined
              hide-details
              label="N° Facture"
              v-model="project.invoice_number"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              outlined
              hide-details
              label="N° Patient"
              v-model="project.patient_number"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              outlined
              hide-details
              label="N° Dossier"
              v-model="project.file_number"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              outlined
              hide-details
              label="N° Appareil"
              v-model="project.device_number"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout justify-space-between wrap mt-3 class="infos-patients">
      <v-flex sm4>
        <v-layout justify-space-between wrap>
          <v-text-field
            outlined
            hide-details
            label="Fiche"
            class="mb-2"
            :value="getTranslatedProductModel(project.product_model)"
            disabled
          ></v-text-field>
          <v-flex sm6>
            <v-text-field
              outlined
              hide-details
              label="Nom"
              :value="project.patient.lastname | uppercase"
              disabled
            ></v-text-field>
          </v-flex>
          <v-flex sm6>
            <v-text-field
              outlined
              hide-details
              label="Prénom"
              :value="project.patient.firstname"
              disabled
            ></v-text-field>
          </v-flex>
          <v-textarea
            filled
            name="Adresse"
            label="Adresse"
            rows="5"
            hide-details
            class="mt-2"
            :value="getFullAddress(project.patient)"
            disabled
          ></v-textarea>
        </v-layout>
      </v-flex>
      <v-flex sm8>
        <v-layout wrap justify-space-between>
          <v-flex sm6 mb-2>
            <v-layout justify-space-between>
              <v-flex>
                <v-text-field
                  outlined
                  hide-details
                  label="N° Sécu"
                  :value="project.patient.nir"
                  disabled
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm6 mb-2>
            <v-text-field
              outlined
              hide-details
              label="Date de naissance"
              :value="project.patient.dob | dateFormat"
              disabled
            ></v-text-field>
          </v-flex>
          <v-text-field
            outlined
            label="Centre"
            class="mb-2"
            v-validate="'max:50'"
            :error-messages="errors.collect('center')"
            data-vv-name="center"
            v-model="project.center"
          ></v-text-field>
          <v-flex sm6 mb-2>
            <v-text-field
              outlined
              hide-details
              label="Téléphone"
              :value="project.patient.phone"
              disabled
            ></v-text-field>
          </v-flex>
          <v-flex sm6 mb-2>
            <v-text-field
              outlined
              hide-details
              label="Portable"
              :value="project.patient.cellular"
              disabled
            ></v-text-field>
          </v-flex>
          <v-text-field
            outlined
            hide-details
            label="E-mail"
            :value="project.patient.email"
            disabled
          ></v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import utils from "@/mixins/utils";

export default {
  name: "ConsultationHeader",
  mixins: [utils],
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  methods: {
    getFullAddress(patient_object) {
      var p_addr = patient_object.address != null ? patient_object.address : "";
      var p_zipcode =
        patient_object.zipcode != null ? patient_object.zipcode : "";
      var p_city = patient_object.city != null ? patient_object.city : "";

      return `${p_addr} ${p_zipcode} ${p_city}`;
    }
  },
  created() {
    this.project.patient_number = this.project.patient.number;
  }
};
</script>

<style lang="scss">
.consultation-header {
  margin-bottom: 30px;
  .layout {
    > .v-input {
      width: 100%;
    }
  }
  .infos-patients {
    background-color: #f9f3f7;
    padding: 15px;
  }
}
</style>
